import { render, staticRenderFns } from "./Mag.vue?vue&type=template&id=5022b5d4&scoped=true"
import script from "./Mag.vue?vue&type=script&lang=js"
export * from "./Mag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022b5d4",
  null
  
)

export default component.exports